<template>

    <div class="canvas::editor-admin-VersionActions ml-auto flex items-center">

        <div
            class="flex"
            :class="{
            'opacity-25': !useVersioning,
            'pointer-events-none': !useVersioning
        }">

            <button
                    v-if="conceptRevertable"
                    class="hover:text-white mr-5 flex items-center justify-center border border-transparent text-base leading-6 font-medium rounded-md text-white bg-red-400 hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out py-2 text-sm px-5"
                    :disabled="versionState === 'live'"
                    @click="resetCanvasVersion">
                Wijzigingen verwijderen
            </button>

            <button
                    v-if="useVersioning"
                    class="hover:text-white mr-5 flex items-center justify-center border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-400 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out py-2 text-sm px-5"
                    :class="{ 'ml-4': !conceptRevertable }"
                    :disabled="versionState === 'live'"
                    @click="activateCanvasVersion">
                Live plaatsen
            </button>

        </div>

        <div x-data="{ tooltip: false }" class="relative">
            <i x-on:mouseover="tooltip = true"
               x-on:mouseleave="tooltip = false"
               class="fas fa-info-circle text-blue-400 mr-5 cursor-pointer">
            </i>
            <div class="relative" x-cloak x-show.transition.origin.left="tooltip">
                <div class="absolute right-0 z-10 w-auto p-2 mr-12 w-auto text-sm leading-tight text-gray-600 transform -translate-y-full bg-white rounded-md shadow-md whitespace-nowrap">
                    {{ useVersioning ? 'Wijzigingen worden niet direct live geplaatst.' : 'Omdat je lokaal werkt worden wijzigingen direct bewaard.' }}
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import Swal from 'sweetalert2';
import axios from 'axios';

export default {

        props: {
            canvasVersion: Object,
            versionState: String,
            useVersioning: Boolean,
            currentLanguage: String,
        },

        data()
        {
            return {
            };
        },

        methods: {

            async resetCanvasVersion()
            {
                // Abort due to user does not confirm?
                const { value: confirmed } = await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Weet u zeker dat u alle wijzigingen wilt verwijderen? U keert dan terug naar de live versie.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, verwijder',
                    confirmButtonColor: '#f62d51',
                    cancelButtonText: 'Annuleer',
                });

                if(!confirmed)
                    return;

                // Send to server.
                await axios.post('/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'canvas-editor/' + this.canvasVersion.id + '/reset');

                // @ugly TODO High: Implement below.
                document.location.reload(true);

                /*
                // Emit update.
                this.$emit('update:canvasVersion', response.data.canvasVersions[this.currentLanguage]);
                this.$emit('canvasVersionBackToLive');

                // Show toast.
                this.$toasted.show('<i class="fas fa-history"></i> Versie gereset naar live.', {
                    duration: 3000,
                    type: 'info',
                    iconPack: 'fontawesome',
                });
                */
            },

            async activateCanvasVersion()
            {
                // Abort due to user does not confirm?
                const { value: confirmed } = await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Weet u zeker dat u deze versie live wilt plaatsen? Bezoekers zien dan de laatste aanpassingen.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, live plaatsen',
                    confirmButtonColor: '#62de43',
                    cancelButtonText: 'Annuleer',
                });

                if(!confirmed)
                    return;

                // Send to server.
                let response = await axios.post('/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'canvas-editor/' + this.canvasVersion.id + '/activate');

                // Emit update.
                this.$emit('onNewCanvasVersions', response.data.canvasVersions);
                this.$emit('canvasVersionBackToLive');

                // Show toast.
                this.$toasted.show('<i class="fas fa-check"></i> Versie live geplaatst!', {
                    duration: 3000,
                    type: 'success',
                    iconPack: 'fontawesome',
                });
            },

        },

        computed: {

            conceptRevertable()
            {
                return this.canvasVersion.created_at != this.canvasVersion.update_at ? true : false;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .canvas\:\:editor-admin-VersionActions {

        button {
            cursor: pointer;
            outline: none !important;

            &[disabled] {
                @apply pointer-events-none;
                opacity: .65;
            }

        }

    }

</style>
